import src from "IMAGE";
export default { src, width: 1255, height: 428, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARUlEQVR42j2KUQ7AIAjFvP9dNZkIAjre2Ic26UeTlkWEVSsO73zSfruEO7YIKEdhhs+BrQwzg6blnK01cA4/EYFOA4MVHyxcXehASqD3AAAAAElFTkSuQmCC"};
